module.exports = __webpack_public_path__ + "img/step-3.55b5680c.jpg";